import React from 'react';

const VcbConnections = React.lazy(() => import('pages/VcbPayment/VcbConnections'));
const routes = [{ path: '/vcb-payment', exact: true, name: 'Kết nối Vietcombank', function: 'VCB_PAYMENT_CONFIG', component: VcbConnections }];
export default routes;
